import { render } from "./MyCommentsPage.vue?vue&type=template&id=def22cc2"
import script from "./MyCommentsPage.vue?vue&type=script&lang=js"
export * from "./MyCommentsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__